/* eslint-disable react/no-danger */
// Modules
import React from 'react';
import { Link } from 'react-router-dom';

// Styles
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import { createMarkup } from 'utilities/utils';

const TopicOverview = ({ topicConfig }) => (
    <Grid container justifyContent="center">
        <Grid
            item
            container
            xs={12}
            lg={6}
            className="topic-overview-container"
        >
            <Paper>
                <Grid item>
                    <h4 className="topic-overview-header">
                        {topicConfig.topicTitle} Overview
                    </h4>
                    <div
                        className="topic-overview-item"
                        dangerouslySetInnerHTML={createMarkup(
                            topicConfig.overview
                        )}
                    ></div>
                </Grid>
                <Grid item className="topic-overview-item">
                    <h4 className="more-details-text">
                        {/* For non-Hodgkin lymphoma, "Hodgkin" must be capitalized per MDH */}
                        For more details on{' '}
                        {topicConfig.topicTitle === 'Non-Hodgkin Lymphoma'
                            ? 'non-Hodgkin lymphoma'
                            : topicConfig.topicTitle.toLowerCase()}
                    </h4>
                    {topicConfig.themes.map((themeOverview) => (
                        <div
                            className="overview-themes-container"
                            key={themeOverview.theme_ID}
                        >
                            <Link
                                className="topic-overview-link"
                                to={`/${topicConfig.topicUrlPath}/${themeOverview.themePath}/${themeOverview.defaultTabPath}`}
                            >
                                {themeOverview.themeTitle}
                            </Link>{' '}
                            -{' '}
                            <div className="overview-theme-text">
                                {themeOverview.themeOverviewText}
                            </div>
                        </div>
                    ))}
                    <div className="overview-theme-about-these-data">
                        About These Data{' '}
                    </div>
                    <div
                        className="overview-theme-text"
                        dangerouslySetInnerHTML={createMarkup(
                            topicConfig.aboutData
                        )}
                    ></div>
                </Grid>
            </Paper>
        </Grid>
    </Grid>
);

export default TopicOverview;
